import React, { useState } from 'react';
import styled from 'styled-components';
import ModalFactory from './Modal';

const ImgCss = styled.img`
    width: ${({ width }) => width};
    height: ${({ height }) => height};

    cursor: ${({ magnify }) => magnify ? 'zoom-in' : 'unset'};

    position: ${({ state }) => state ? 'absolute' : 'unset'};
`;

const Image = ({ src, width = '100%', height = 'auto', magnify, ...props }) => {

    return (
        <ImgCss
            src={src}
            width={width}
            height={height}
            magnify={magnify}

            onClick={() => {
                if (!magnify) return;

                ModalFactory.show({
                    title: props.modalTitle,
                    body: (
                        <ImgCss
                            src={src}
                            width={'49svw'}
                            height={'auto'}
                            {...props}
                        />
                    )
                })
            }}
            {...props}
        />
    );
}

export default Image;